import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        // Existing translations
        welcome: "Welcome to Anantarra Digital Portal",
        jobTask: "Job Task",
        hazards: "Hazards",
        controls: "Controls",
        location: "Location",
        attachments: "Attachments",
        status: "Status",
        assignedTo: "Assigned To",
        dueDate: "Due Date",
        submit: "Submit",
        formType: "Form Type",
        audit: "Audit",
        jsa: "JSA",
        incident: "Incident",
        language: "Language",
        documentNumber: "Document Number",
        track: "Track",
        noFormFound: "No form found with that document number.",
        formSubmitted: "Form submitted. Document Number: {{documentNumber}}",

        // Navigation
        nav: {
          logo: "Anantarra Digital Portal",
          home: "Home",
          about: "About",
          contact: "Contact",
          faq: "FAQ",
          portal: "Portal",
          logout: "Logout",
          login: "Login",
          register: "Register"
        },

        // Login
        login: {
          title: "Login to Your Account",
          subtitle: "Enter your credentials to access the safety portal",
          username: "Username",
          password: "Password",
          loading: "Logging in...",
          button: "Login",
          noAccount: "Don't have an account?",
          register: "Register here"
        },

        // Register
        register: {
          title: "Create New Account",
          subtitle: "Register to access the safety portal",
          username: "Username",
          password: "Password",
          confirmPassword: "Confirm Password",
          passwordMismatch: "Passwords do not match",
          loading: "Creating account...",
          button: "Register",
          haveAccount: "Already have an account?",
          login: "Login here"
        },

        // Home Page
        home: {
          hero: {
            title: "Anantarra Digital Portal - Thai Rural Hemp Project",
            subtitle: "Comprehensive safety management system for industrial hemp cultivation and export operations",
            getStarted: "Get Started",
            learnMore: "Learn More"
          },
          features: {
            title: "Key Features",
            subtitle: "Our comprehensive safety management system provides everything you need for compliant operations",
            safety: {
              title: "Safety First",
              description: "Integrated safety protocols, hazard identification, and emergency response procedures for all operations."
            },
            compliance: {
              title: "Full Compliance",
              description: "Automated compliance tracking, documentation, and reporting to meet all regulatory requirements."
            },
            sustainability: {
              title: "Sustainable Practices",
              description: "Environmentally responsible cultivation methods with carbon footprint monitoring and reduction targets."
            }
          },
          cta: {
            title: "Ready to Improve Your Safety Operations?",
            subtitle: "Join thousands of hemp cultivation professionals using our comprehensive safety management system",
            button: "Contact Point Inquiry"
          }
        },

        // About Page
        about: {
          roles: {
            farmManager: "Farm Manager",
            farmManagerDesc: "Ensure SOP implementation and supervise field operations",
            safetyOfficer: "Safety Officer",
            safetyOfficerDesc: "Lead observations and compile hazard reports",
            fieldTechnicians: "Field Technicians",
            fieldTechniciansDesc: "Execute tasks and participate in training drills"
          }
        },

        // FAQ Page
        faq: {
          title: "Frequently Asked Questions",
          subtitle: "Find answers to common questions about hemp cultivation safety and compliance",
          contact: {
            title: "Still Have Questions?",
            subtitle: "Our team is here to help you with any additional questions",
            button: "Contact Us"
          }
        },

        // Contact Page
        contact: {
          title: "Contact Us",
          subtitle: "Get in touch with our safety compliance team",
          info: {
            title: "Contact Information",
            address: "Address",
            addressValue: "123 Hemp Street, Agricultural District, Bangkok 10110, Thailand",
            phone: "Phone",
            phoneValue: "+66 2 123 4567",
            email: "Email",
            emailValue: "info@safetyportal.com",
            hours: "Business Hours",
            hoursValue: "Monday - Friday: 8:00 AM - 5:00 PM"
          },
          emergency: {
            title: "Emergency Contact",
            description: "For immediate safety concerns or emergencies, contact our 24/7 emergency hotline",
            phone: "Emergency Hotline",
            phoneValue: "+66 2 987 6543"
          },
          form: {
            title: "Send us a Message",
            name: "Full Name",
            namePlaceholder: "Enter your full name",
            email: "Email Address",
            emailPlaceholder: "Enter your email address",
            subject: "Subject",
            subjectPlaceholder: "What is this regarding?",
            message: "Message",
            messagePlaceholder: "Please provide details about your inquiry...",
            send: "Send Message",
            sending: "Sending...",
            success: "Thank you for your message! We'll get back to you soon.",
            error: "Sorry, there was an error sending your message. Please try again.",
            errors: {
              nameRequired: "Please enter your name",
              emailInvalid: "Please enter a valid email address",
              subjectRequired: "Please enter a subject",
              messageRequired: "Please enter your message"
            }
          }
        },

        // Form Templates
        form: {
          createNew: "Create New Form",
          selectType: "Select Form Type",
          submitting: "Submitting form...",
          submittedSuccess: "Form submitted successfully!",
          submitFailed: "Failed to submit form",
          templateError: "Error Loading Form Template",
          templateErrorMessage: "Unable to load the form template. Please try again later.",
          backToList: "Back to Form List",
          qrCodeTitle: "QR Code for Document",
          documentNumber: "Document Number",
          print: "Print QR Code",
          printQR: "Print QR Code",
          validation: {
            required: "{{field}} is required"
          },
          submit: "Submit",
          cancel: "Cancel"
        },
      },
    },
    th: {
      translation: {
        // Existing translations
        welcome: "ยินดีต้อนรับสู่พอร์ทัลดิจิทัล อนันต์ธารา",
        jobTask: "งานที่ทำ",
        hazards: "อันตราย",
        controls: "การควบคุม",
        location: "สถานที่",
        attachments: "ไฟล์แนบ",
        status: "สถานะ",
        assignedTo: "มอบหมายให้",
        dueDate: "กำหนดส่ง",
        submit: "ส่งแบบฟอร์ม",
        formType: "ประเภทแบบฟอร์ม",
        audit: "ตรวจสอบ",
        jsa: "JSA",
        incident: "อุบัติเหตุ",
        language: "ภาษา",
        documentNumber: "เลขที่เอกสาร",
        track: "ติดตาม",
        noFormFound: "ไม่พบแบบฟอร์มตามเลขที่เอกสารนี้",
        formSubmitted: "ส่งแบบฟอร์มแล้ว เลขที่เอกสาร: {{documentNumber}}",

        // Navigation
        nav: {
          logo: "พอร์ทัลดิจิทัล อนันต์ธารา",
          home: "หน้าแรก",
          about: "เกี่ยวกับ",
          contact: "ติดต่อ",
          faq: "คำถามที่พบบ่อย",
          portal: "พอร์ทัล",
          logout: "ออกจากระบบ",
          login: "เข้าสู่ระบบ",
          register: "ลงทะเบียน"
        },

        // Login
        login: {
          title: "เข้าสู่ระบบบัญชีของคุณ",
          subtitle: "กรุณากรอกข้อมูลเพื่อเข้าถึงพอร์ทัลความปลอดภัย",
          username: "ชื่อผู้ใช้",
          password: "รหัสผ่าน",
          loading: "กำลังเข้าสู่ระบบ...",
          button: "เข้าสู่ระบบ",
          noAccount: "ยังไม่มีบัญชี?",
          register: "ลงทะเบียนที่นี่"
        },

        // Register
        register: {
          title: "สร้างบัญชีใหม่",
          subtitle: "ลงทะเบียนเพื่อเข้าถึงพอร์ทัลความปลอดภัย",
          username: "ชื่อผู้ใช้",
          password: "รหัสผ่าน",
          confirmPassword: "ยืนยันรหัสผ่าน",
          passwordMismatch: "รหัสผ่านไม่ตรงกัน",
          loading: "กำลังสร้างบัญชี...",
          button: "ลงทะเบียน",
          haveAccount: "มีบัญชีอยู่แล้ว?",
          login: "เข้าสู่ระบบที่นี่"
        },

        // Home Page
        home: {
          hero: {
            title: "พอร์ทัลดิจิทัล อนันต์ธารา - โครงการกัญชงในชนบทไทย",
            subtitle: "ระบบการจัดการความปลอดภัยอย่างครอบคลุมสำหรับการปลูกและการส่งออกกัญชงอุตสาหกรรม",
            getStarted: "เริ่มต้นใช้งาน",
            learnMore: "เรียนรู้เพิ่มเติม"
          },
          features: {
            title: "คุณสมบัติหลัก",
            subtitle: "ระบบการจัดการความปลอดภัยอย่างครอบคลุมของเราให้ทุกสิ่งที่คุณต้องการสำหรับการดำเนินงานที่ปฏิบัติตามข้อกำหนด",
            safety: {
              title: "ความปลอดภัยเป็นอันดับแรก",
              description: "โปรโตคอลความปลอดภัยแบบบูรณาการ การระบุอันตราย และขั้นตอนการตอบสนองฉุกเฉินสำหรับการดำเนินงานทั้งหมด"
            },
            compliance: {
              title: "การปฏิบัติตามข้อกำหนดอย่างสมบูรณ์",
              description: "การติดตามการปฏิบัติตามข้อกำหนด อ้างอิง และรายงานอัตโนมัติเพื่อให้เป็นไปตามข้อกำหนดของกฎระเบียบทั้งหมด"
            },
            sustainability: {
              title: "แนวทางปฏิบัติที่ยั่งยืน",
              description: "วิธีการปลูกที่มีความรับผิดชอบต่อสิ่งแวดล้อมด้วยการตรวจสอบและการลดการปล่อยก๊าซคาร์บอน"
            }
          },
          cta: {
            title: "พร้อมที่จะปรับปรุงการดำเนินงานด้านความปลอดภัยของคุณแล้วหรือยัง?",
            subtitle: "เข้าร่วมกับผู้เชี่ยวชาญด้านการปลูกกัญชงหลายพันคนที่ใช้ระบบการจัดการความปลอดภัยอย่างครอบคลุมของเรา",
            button: "สอบถามจุดติดต่อ"
          }
        },

        // About Page
        about: {
          roles: {
            farmManager: "ผู้จัดการฟาร์ม",
            farmManagerDesc: "รับรองการใช้งาน SOP และดูแลการดำเนินงานในสนาม",
            safetyOfficer: "เจ้าหน้าที่ความปลอดภัย",
            safetyOfficerDesc: "นำการสังเกตและรวบรวมรายงานอันตราย",
            fieldTechnicians: "ช่างเทคนิคในสนาม",
            fieldTechniciansDesc: "ดำเนินการตามงานและเข้าร่วมการฝึกซ้อม"
          }
        },

        // FAQ Page
        faq: {
          title: "คำถามที่พบบ่อย",
          subtitle: "ค้นหาคำตอบสำหรับคำถามทั่วไปเกี่ยวกับความปลอดภัยและการปฏิบัติตามข้อกำหนดในการปลูกกัญชง",
          contact: {
            title: "ยังมีคำถามอื่นๆ หรือไม่?",
            subtitle: "ทีมของเราอยู่ที่นี่เพื่อช่วยคุณกับคำถามเพิ่มเติมใดๆ",
            button: "ติดต่อเรา"
          }
        },

        // Contact Page
        contact: {
          title: "ติดต่อเรา",
          subtitle: "ติดต่อกับทีมการปฏิบัติตามข้อกำหนดด้านความปลอดภัยของเรา",
          info: {
            title: "ข้อมูลการติดต่อ",
            address: "ที่อยู่",
            addressValue: "123 ถนนกัญชง เขตเกษตรกรรม กรุงเทพฯ 10110 ประเทศไทย",
            phone: "โทรศัพท์",
            phoneValue: "+66 2 123 4567",
            email: "อีเมล",
            emailValue: "info@safetyportal.com",
            hours: "เวลาทำการ",
            hoursValue: "จันทร์ - ศุกร์: 8:00 น. - 17:00 น."
          },
          emergency: {
            title: "ติดต่อฉุกเฉิน",
            description: "สำหรับความกังวลด้านความปลอดภัยที่ทันทีหรือเหตุฉุกเฉิน ติดต่อสายด่วนฉุกเฉิน 24/7 ของเรา",
            phone: "สายด่วนฉุกเฉิน",
            phoneValue: "+66 2 987 6543"
          },
          form: {
            title: "ส่งข้อความถึงเรา",
            name: "ชื่อ-นามสกุล",
            namePlaceholder: "กรุณากรอกชื่อ-นามสกุลของคุณ",
            email: "ที่อยู่อีเมล",
            emailPlaceholder: "กรุณากรอกที่อยู่อีเมลของคุณ",
            subject: "หัวข้อ",
            subjectPlaceholder: "เรื่องนี้เกี่ยวกับอะไร?",
            message: "ข้อความ",
            messagePlaceholder: "กรุณาระบุรายละเอียดเกี่ยวกับคำถามของคุณ...",
            send: "ส่งข้อความ",
            sending: "กำลังส่ง...",
            success: "ขอบคุณสำหรับข้อความของคุณ! เราจะติดต่อกลับโดยเร็ว",
            error: "ขออภัย เกิดข้อผิดพลาดในการส่งข้อความของคุณ กรุณาลองใหม่อีกครั้ง",
            errors: {
              nameRequired: "กรุณากรอกชื่อของคุณ",
              emailInvalid: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
              subjectRequired: "กรุณากรอกหัวข้อ",
              messageRequired: "กรุณากรอกข้อความของคุณ"
            }
          }
        },

        // Form Templates
        form: {
          createNew: "สร้างแบบฟอร์มใหม่",
          selectType: "เลือกประเภทแบบฟอร์ม",
          submitting: "กำลังส่งแบบฟอร์ม...",
          submittedSuccess: "ส่งแบบฟอร์มสำเร็จแล้ว!",
          submitFailed: "ไม่สามารถส่งแบบฟอร์มได้",
          templateError: "เกิดข้อผิดพลาดในการโหลดเทมเพลตแบบฟอร์ม",
          templateErrorMessage: "ไม่สามารถโหลดเทมเพลตแบบฟอร์มได้ กรุณาลองใหม่อีกครั้งในภายหลัง",
          backToList: "กลับไปที่รายการแบบฟอร์ม",
          qrCodeTitle: "รหัส QR สำหรับเอกสาร",
          documentNumber: "เลขที่เอกสาร",
          print: "พิมพ์รหัส QR",
          printQR: "พิมพ์รหัส QR",
          validation: {
            required: "จำเป็นต้องกรอก {{field}}"
          },
          submit: "ส่ง",
          cancel: "ยกเลิก"
        },

        // Footer
        footer: {
          company: "พอร์ทัลดิจิทัล อนันต์ธารา",
          description: "การจัดการความปลอดภัยอย่างครอบคลุมสำหรับการปลูกและการส่งออกกัญชงอุตสาหกรรม",
          copyright: "โครงการกัญชงในชนบทไทย",
          rights: "สงวนลิขสิทธิ์ทั้งหมด"
        }
      },
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
